import * as TransportistActions from './transportist';

const Actions = {
  ...TransportistActions,
};

export default Actions;
